// hooks/useHeartbeat.js
import { useEffect } from 'react';
import { fetchWithAuth } from '../services/api';

export function useHeartbeat(intervalMs) {
  useEffect(() => {
    if (!intervalMs) return;

    const send = async () => {
      const token = sessionStorage.getItem('jwt_token');
      if (!token) return;

      try {
        const res = await fetchWithAuth('/api/public/heartbeat', { method: 'POST' });
        if (res.status === 401) {
          console.warn('[Heartbeat] 401 – token utgången, laddar om sidan');
          sessionStorage.clear();
          window.location.reload();
        }
      } catch (err) {
        console.warn('[Heartbeat] misslyckades:', err.message);
      }
    };

    send();
    const id = setInterval(send, intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
}